import {
  selectBrand,
  selectFavoriteFilter,
  selectProvider,
  selectTag,
} from "@shared/actions/games";
import { SHOW_ALL, TAG_FAVORITE } from "@shared/constants/game";
import { useCurrentProviderId, useProviders } from "@shared/hooks/games";
import { TAG_RECOMMENDED } from "@shared/modules/recommended-games";
import { filterService } from "@shared/services/query-filter-service/query-filter-service";
import { useCallback, useMemo, useRef } from "react";
import { useDispatch } from "react-redux";

export const useApplyFilters = () => {
  const isApplied = useRef(false);
  const dispatch = useDispatch();
  const providers = useProviders();
  const currentProviderId = useCurrentProviderId();

  const providerId = useMemo(
    () =>
      filterService.getFilterParams?.provider?.id ??
      currentProviderId ??
      providers[0]?.id,
    [currentProviderId, providers]
  );

  const brandId = filterService.getFilterParams?.brandId ?? SHOW_ALL;
  const tagId = filterService.getFilterParams?.tagId ?? SHOW_ALL;
  const tagFavorite = filterService.getFilterParams?.tagId === TAG_FAVORITE;
  const tagRecommended =
    filterService.getFilterParams?.tagId === TAG_RECOMMENDED;

  const handleFilterApply = useCallback(() => {
    setTimeout(() => {
      if (providerId) {
        dispatch(selectProvider(providerId));
      }
      dispatch(selectBrand(brandId));

      if (tagFavorite) {
        dispatch(selectFavoriteFilter(true));
      } else if (tagRecommended) {
        dispatch(selectTag(TAG_RECOMMENDED));
      } else {
        dispatch(selectTag(tagId));
      }
    }, 1000);
  }, []);

  return { isFilterApplied: isApplied, handleFilterApply };
};
